var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-stepper',{staticClass:"elevation-0 pulse-stepper",attrs:{"value":_vm.value,"alt-labels":""}},[_c('v-stepper-header',{staticClass:"d-flex justify-end"},[_c('v-stepper-step',{attrs:{"step":"1"}}),_c('v-divider'),_c('v-stepper-step',{attrs:{"step":"2"}}),_c('v-divider'),_c('v-stepper-step',{attrs:{"step":"3"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }